import React from "react";
import loader from "../images/main-loader.jpg";
import { MoonLoader } from "react-spinners";


const LoadScreen = () => {
  return (
    <div className="loaderDiv">
      <img src={loader} height="200" alt="AVION" />
      <div className="MoonLoaderDiv">
        <MoonLoader color="#1B4C8C" />
      </div>
    </div>
  );
};

export default LoadScreen;
